//@ts-ignore
//eslint-disable-next-line
export default function guest({to, from, next, store, i18n}){
    if (store.getters["auth/isLogged"]) {

        if (to.name == "Login") {
            next({
                name: "venta",
                params: { lang: i18n.locale },
                replace: false,
            });
        }

        next({
          name: "Login",
          params: { lang: i18n.locale },
          replace: true,
        });
    }else{
        next();
    }
}